import store from '../../../redux/store'

import { history } from '../../../helpers/history'

const currentFilters = (tab, returnSelectedRow = false) => {
  const { uiReducer } = store.getState()
  const [currentLocation] = history.location.pathname.split('/:')

  let array = []

  const filtercurrentLocation =
    uiReducer &&
    uiReducer.filterTable.find(
      (f) => f.location === currentLocation && f.tab === tab,
    )
  let convertToArray = filtercurrentLocation?.filters || []
  convertToArray.map((x) => {
    array[x.columnId] = x.value
  })

  return returnSelectedRow ? filtercurrentLocation?.selectedRow : array
}

export const insertToColumns = (columns, tab) => {
  const currentFilter = currentFilters(tab)
  let updatedColumns = columns.map((c, index) => {
    return { ...c, defaultFilter: currentFilter[index] }
  })
  return updatedColumns
}

export const findSelectedRow = (tab) => {
  return currentFilters(tab, true)
}
